import { defineMessages } from 'react-intl';

export const viewFormModalMessages = defineMessages({
  cannotEditHeidiTemplate: {
    defaultMessage: "You cannot edit Heidi templates, so we've created your own copy",
    id: 'zWCamerPF2',
    description:
      'Toast when saving a protected Heidi form template creates a personal copy',
  },
  cannotEditTeamTemplate: {
    defaultMessage: "You cannot edit team templates, so we've created your own copy",
    id: '/kfYX7dCF+',
    description:
      'Toast when saving a protected team form template creates a personal copy',
  },
  cannotEditSharedTemplate: {
    defaultMessage: "You cannot edit shared templates, so we've created your own copy",
    id: 'mSbwGvuZt9',
    description:
      'Toast when saving a protected shared form template creates a personal copy',
  },
  cannotEditProtectedTemplate: {
    defaultMessage: "You can't edit this template, so we've created your own copy",
    id: 'ybkwYnf8LC',
    description:
      'Neutral toast when saving a protected form template creates a personal copy',
  },
});
